import { MpsAction } from '@mps/mps-kit/mps-button';
import { MpsTableTemplate } from '@mps/mps-kit/mps-table';

export const hpc_table_templates: Record<string, MpsTableTemplate> = {
  test: {
    btemplate: 'table:crud',
  },
} as const;

export const hpc_table_factory_templates: Record<string, () => MpsTableTemplate> = {
  default: () =>
    ({
      id: 'default',
      title: '',
      subtitle: '',
      displayMode: 'display.list',
      showTitleSection: true,
      showSearchSection: true,
      showHookBeforTableSection: false,
      showSearch: true,
      showExpandableRows: false,
      showLoading: false,
      showFilters: false,
      responsive: true,
      rowClickAction: false,
      stickyHeader: false,
      useCardForMobile: true,

      buildButtonsWithTemplate: false,
      enableDebug: true,
      paginationStrategy: 'pagination.client',
      pageSize: 10,
      pageSizeOptions: [5, 10, 30],

      cardModeConfig: {
        gridCard: {
          backgroundColor: '#f5f5f5',
        },
        gridColumns: [1, 2, 4],
        gridMinWidth: '300px',
        ngGridCardTemplate: null,
      },
    }) satisfies MpsTableTemplate,

  'table:crud': () =>
    ({
      id: 'table:crud',
      title: 'entities.%entity%.table.title',
      subtitle: 'entities.%entity%.table.subtitle',
      displayMode: 'display.list',
      showTitleSection: true,
      showSearchSection: true,
      showHookBeforTableSection: false,
      showExpandableRows: false,
      responsive: true,
      rowClickAction: true,
      stickyHeader: false,
      useCardForMobile: true,

      enableDebug: true,
      buildButtonsWithTemplate: true,
      paginationStrategy: 'pagination.client',
      pageSize: 10,
      pageSizeOptions: [10, 20, 50],
      cardModeConfig: {
        gridCard: {
          title: (data: any) => data?.firstname + ' ' + data?.lastname,
          subtitle: (data: any) => data?.job || '',
          icon: (data: any) => data?.icon || '',
          elevation: 24,
        },
        gridColumns: [1, 2, 4],
        gridMinWidth: '300px',
        ngGridCardTemplate: null,
      },

      tlButtons: [{ btemplate: MpsAction.TABLE_EXPORT_CSV }],
      trButtons: [{ btemplate: MpsAction.IMPORT_ENTITIES }],
      actionButtons: [
        { btemplate: MpsAction.EDIT_ENTITY },
        { btemplate: MpsAction.VIEW_ENTITY },
        { btemplate: MpsAction.DELETE_ENTITY },
      ],
      blButtons: [
        {
          btemplate: MpsAction.TABLE_EXPORT_SELECTED_CSV,
          disabled: (element: any, context: any) => {
            return context.selectedRows?.length === 0;
          },
        },
      ],
    }) satisfies MpsTableTemplate,

  'table:hpc-view-field': () =>
    ({
      panel: {
        btemplate: 'panel:view_field_table',
      },
      showSearch: false,
      paginationStrategy: 'pagination.none',
      showSearchSection: true,
      showTitleSection: false,
      pageSize: 5,
      pageSizeOptions: [5, 10, 20],
      tlButtons: [{ btemplate: MpsAction.TABLE_TOGGLE_DISPLAY_LIST_GRID_MODE }],
    }) satisfies MpsTableTemplate,

  table_config: () =>
    ({
      id: 'table_config',
      displayMode: 'display.list',
      showTitleSection: true,
      showSearchSection: true,
      showHookBeforTableSection: false,
      showExpandableRows: false,
      responsive: true,
      rowClickAction: true,
      stickyHeader: false,
      useCardForMobile: true,

      enableDebug: true,
      buildButtonsWithTemplate: true,
      paginationStrategy: 'pagination.client',
      pageSizeOptions: [10, 20, 50],

      cardModeConfig: {
        gridColumns: [1, 2, 4],
        gridMinWidth: '300px',
        ngGridCardTemplate: null,
        gridCard: {
          title: (data: any) => data?.firstname + ' ' + data?.lastname || '',
          subtitle: (data: any) => data?.job || '',
          icon: (data: any) => data?.icon || '',
          elevation: 24,
        },
      },

      tlButtons: [{ btemplate: MpsAction.TABLE_EXPORT_CSV }],
      trButtons: [{ btemplate: MpsAction.IMPORT_ENTITIES }],
      actionButtons: [
        { btemplate: MpsAction.EDIT_ENTITY },
        { btemplate: MpsAction.VIEW_ENTITY },
        { btemplate: MpsAction.DELETE_ENTITY },
      ],
      blButtons: [
        {
          btemplate: MpsAction.TABLE_EXPORT_SELECTED_CSV,
          disabled: (element: any, context: any) => {
            return context.selectedRows?.length === 0;
          },
        },
      ],
      toolbarButtons: [
        { btemplate: MpsAction.TABLE_TOGGLE_DISPLAY_LIST_GRID_MODE },
        { btemplate: MpsAction.TABLE_CONFIG },
        { btemplate: MpsAction.TABLE_COLUMNS_CONFIG },
        { btemplate: MpsAction.ADD_ENTITY, type: 'button.primary' },
      ],
    }) satisfies MpsTableTemplate,
};
